<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title class="headline">Sunteti sigur ca doriti stergerea platii?</v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="$emit('close')">Anulare</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        props: {
            payment: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
            expense: {
                type: Object,
                required: true,
                default() {
                    return {}
                }
            },
            dialog: {
                type: Boolean,
                default() {
                    return false
                }
            },
            title: {
                type: String,
                default() {
                    return 'Anulare plata'
                }
            }
        },
        methods: {
            async deleteItemConfirm() {
                const self = this
                const modelEndpoint = (new this.$db.Expense()).endpoint()
                await this.axios.delete(`${modelEndpoint}/${this.expense.id}/payments/${this.payment.id}`).then(() => {
                    self.showSuccess();
                    self.$emit('close', true)
                })
                .catch(errors => {
                    this.showError()
                })
            }
        }
    }
</script>
